/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/promotion';

/**
 * applyPromotion
 * url - /checkout/{apiversion}/cart/{cartId}/promotion?brand={brandId}
 *
 * @param {Object} args
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.promotionCode
 * @param {String} args.membershipCode
 * @param {String} args.billingZipCode
 */

const applyPromotion = ({
    env, jwtToken, cartId, promotionCode,
    membershipCode, billingZipCode, attributes,
    bannerCode, email,
}) => {
    const envObj = env || {};
    const payload = {
        bannerCode,
        cartId,
        promotionCode,
        membershipCode,
        billingZipCode,
        attributes,
        email,
    };

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;
    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}`;
    return restClient.postRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default applyPromotion;
